import { createFormView } from '../services/form-view';
import React, { createContext, useContext, useMemo } from 'react';
const FormViewContext = /*#__PURE__*/createContext(undefined);
export const FormViewProvider = _ref => {
  let {
    form,
    stepId,
    children
  } = _ref;
  const value = useMemo(() => {
    const formView = createFormView({
      form,
      stepId,
      includeHiddenFields: true
    });
    return formView;
  }, [form, stepId]);
  return /*#__PURE__*/React.createElement(FormViewContext.Provider, {
    value: value
  }, children);
};
export const useFormView = () => {
  const context = useContext(FormViewContext);
  if (context === undefined) {
    throw new Error('useFormView must be used within a FormViewProvider');
  }
  return context;
};
//# sourceMappingURL=form-view-provider.js.map